import {useMutation} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

export const useUpdateNumberSettings = () => {
    const locale = useLocale();

    return useMutation<
        Api.Response.Template.SuccessBasicMessage,
        Error,
        Record<string, string>
    >({
        mutationFn: (formData) =>
            request({
                formData: toSnakeCase(formData),
                locale,
                method: 'POST',
                url: window.Urls.numbering_settings_edit_view(),
            }),
    });
};
